import PersonalSizeBenefit from "./OverlayViewUniversalSize0BenefitStart";

interface Props {
    handleBack: () => void;
    handleNext: (updatedCurrentFlowData: any) => void;
    isStoreScreen?: boolean
}

export default function BenefitLayout({ handleBack, handleNext, isStoreScreen=true }: Props) {
    return (
        <PersonalSizeBenefit handleBack={handleBack} handleNext={handleNext} isDesktop={true} manualMediaWidth={isStoreScreen ? '' : '100%'}/>
    );
    
}